<template>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
    <div class="col pb-3" v-if="isStandardOrLawUser">
      <AlertsWidget></AlertsWidget>
    </div>
    <div class="col pb-3" v-if="isStandardUser">
      <AnnouncementsWidget></AnnouncementsWidget>
    </div>
    <div class="col pb-3" v-if="isStandardUser">
      <SchedulesAndBellsWidget></SchedulesAndBellsWidget>
    </div>
    <div class="col pb-3" v-if="isStandardUser && machine_type === 'Box' && feature_text_notification_widget_enabled">
      <TextBasedNotificationWidget></TextBasedNotificationWidget>
    </div>
    <div class="col pb-3" v-if="isStandardUser">
      <ZonesAndDevicesWidget></ZonesAndDevicesWidget>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AlertsWidget from '../components/Widgets/AlertsWidget/AlertsWidget.vue';
import AnnouncementsWidget from '../components/Widgets/AnnouncementsWidget/AnnouncementsWidget.vue';
import ZonesAndDevicesWidget from '../components/Widgets/ZonesAndDevicesWidget/ZonesAndDevicesWidget.vue';
import SchedulesAndBellsWidget from '../components/Widgets/SchedulesAndBellsWidget/SchedulesAndBellsWidget.vue';
import TextBasedNotificationWidget from '../components/Widgets/TextBasedNotificationWidget/TextBasedNotificationWidget.vue';
import router from '../router'

export default {
  name: 'home',
  components: { AlertsWidget, AnnouncementsWidget, SchedulesAndBellsWidget, ZonesAndDevicesWidget, TextBasedNotificationWidget },
  computed: {
    ...mapGetters({
      is_authenticated: 'isAuthenticated',
      logged_in_user: 'loggedInUser',
      is_active_alert_event: 'isActiveAlertEvent',
      feature_g2_secure_enabled: 'featureG2SecureEnabled',
      feature_text_notification_widget_enabled: 'featureTextNotificationWidgetEnabled',
      machine_type: 'machineType'
    }),
    isStandardUser: function () {
      return this.is_authenticated && [1,2,3,4].includes(this.logged_in_user.group_id)
    },
    isStandardOrLawUser: function () {
      return this.is_authenticated && [1,2,3,4,7].includes(this.logged_in_user.group_id)
    }
  },
  created () {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')

    if (this.is_active_alert_event && this.feature_g2_secure_enabled) {
      router.push({ name: 'AlertDashboard' })
    }
  }
}
</script>
